<template>
	<div>
		<div class="Loader--Cube">
			<div class="Cube Cube1"></div>
			<div class="Cube Cube2"></div>
			<div class="Cube Cube4"></div>
			<div class="Cube Cube3"></div>
		</div>
	</div>
</template>